import StorageServiceRepository from "../usecases/ports/storageServiceRepository";
import { firebaseStorage, refStorage, getDownloadURL, uploadBytes, getBlob } from "../../firebase";
import { getFileExtension } from "../../utils/strings";

export default class StorageServiceFirebaseImpl implements StorageServiceRepository {
  uploadImage = async (
    image: Blob | File,
    fileName: string
    //destination
  ): Promise<string | undefined> => {
    try {
      const fileExtension = getFileExtension(fileName);
      
      const storageRef = refStorage(firebaseStorage, `${Date.now()}.${fileExtension}`);

      await uploadBytes(storageRef, image);
      return getDownloadURL(storageRef);
    } catch (error) {
      throw error;
    }
  };

  downloadFile = async (
    fileUrl: string,
    customFileName?: string,
  ): Promise<void> => {
    try {
      const fileNameArr = fileUrl.split('/');
      const filePopArr = fileNameArr.pop();
      const fileName = decodeURI(filePopArr?.split('?')?.[0] || '');
      const storageRef = refStorage(firebaseStorage, fileName);
      const blob = await getBlob(storageRef);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = customFileName || fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      throw error;
    }
  };
}
